module.exports = __webpack_public_path__ + "img/search-icon.17ca884b.png";